'use client'

import { Dialog } from '@vinted/web-ui'

import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

import Slides from './Slides'

const getModalContentDimensions = (isNewVariant: boolean) => {
  if (isNewVariant) {
    return {
      height: 'calc(100% - 80px)',
      maxHeight: '744px',
      width: 'min(412px, 100vw)',
    }
  }

  return {
    height: 'calc(100% - 80px)',
    maxHeight: '812px',
  }
}

type PhishingFirstTimeListerEducationProps = {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

const PhishingFirstTimeListerEducation = ({
  isOpen,
  setIsOpen,
}: PhishingFirstTimeListerEducationProps) => {
  const phishingEducationAbTest = useAbTest('first_time_lister_education_ui_in_stories')
  const isNewVariant = phishingEducationAbTest?.variant === 'on'

  const modalContentDimensions = getModalContentDimensions(isNewVariant)

  return (
    <Dialog
      show={isOpen}
      contentDimensions={modalContentDimensions}
      testId="phishing-first-time-lister-education-modal"
    >
      <Slides setIsDialogOpen={setIsOpen} />
    </Dialog>
  )
}

export default PhishingFirstTimeListerEducation
